<template>
<div>
</div>
</template>

<script>
import { useClient, useMutation } from 'villus';
import { gql } from 'graphql-tag';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'queryServerTime',

  setup() {
    const store = useStore();

    useClient({
      url: process.env.VUE_APP_STRAPI,
      cachePolicy: 'network-only',
    });

    const queryServerTime = gql`
      query {
        getServerTime {
          serverTime
        }
      }
    `;

    const context = reactive({
      headers: computed(() => store.state.auth.headers),
    });

    const { execute: queryServerTimeEx } = useMutation(queryServerTime, {
      context,
    });

    store.commit('setStrapiExecutionHandler', { item: 'queryServerTimeEx', result: queryServerTimeEx });
  },
};
</script>
